module.exports = __webpack_public_path__ + "img/loss.1c21caf6.png";